import { Course, BlockUnitCompletionMap } from "@sparkademy/app-common/models/course";
import { atom } from "jotai";

export const courseAtom = atom<Course | null>(null);
export const blockUnitCompletionMapAtom = atom<BlockUnitCompletionMap | null>(null);
export const lessonNavigatorVisibleAtom = atom<boolean>(true);
